export default function getValidHref(value: string, type: string) {
  switch (type) {
    case 'email':
      return `mailto:${value}`;
    case 'call':
      return `tel:${value}`;
    default:
      return value;
  }
}

// mailto:, tel: and sms: hand off to an app, so a new tab would be left blank
export function isSelfTarget(type: string) {
  return ['email', 'call', 'sms'].includes(type);
}
